import React, { useEffect } from 'react';
import { AuFormItemWrapper } from 'components/DTA';
import { getSRARNsIndividual } from 'PortalStore/Actions/SRARNsIndividualActions';
import { useDispatch, useSelector } from 'react-redux';
import { useFormikContext } from 'formik';
import { getIdentityDocumentTitleAndDataModel } from 'helpers/arnApplicationHelper';
import { ArnApplicationDvsMethodFormData } from 'types/forms/arnApplicationTypes';
import { IDENTITY_TYPES } from 'arnConstants';

interface ApplicationSuccessfulProps {
  userEmail: string;
  arnType: string;
  arnPath: string;
}

const ApplicationSuccessful: React.FC<ApplicationSuccessfulProps> = (props: ApplicationSuccessfulProps) => {
  const B2CSettings = useSelector((state: any) => state.B2CSettings);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getSRARNsIndividual(B2CSettings.items.webappurlPortalApi, B2CSettings.items.accesstokenPortal));
  }, []);

  const { values, getFieldMeta } = useFormikContext<ArnApplicationDvsMethodFormData>();
  let isDvsPassed = false;
  if (values.identityType && values.identityType !== IDENTITY_TYPES.MANUAL_UPLOAD) {
    const identityType = getIdentityDocumentTitleAndDataModel(values.identityType);
    const dvsValidationIndicator = getFieldMeta(`${identityType.identityType}.dvsValidationIndicator`).value;
    isDvsPassed = dvsValidationIndicator === 'Passed';
  };

  const dvsCheckSuccessMessage = (<><p>
    Thank you for {props.arnType === 'new' ? 'applying for an' : 'linking your'} aviation reference number.
    We are processing your request. Once complete we will send an email confirming your {props.arnType === 'new' ? '' : 'linked'} aviation reference
    number to <strong>{props.userEmail}</strong>.
  </p>
  <p>You should receive this email within the next 2 minutes.</p>
  </>);

  const dvsCheckFailoursMessage = (<p>Thank you for {props.arnType === 'new' ? 'applying for an' : 'creating an account and linking your'} aviation reference number.
    We are processing your request and will aim to have your application completed within five business days.
    Once complete we will send an email confirming your aviation reference number to <strong>{props.userEmail}</strong>.</p>);

  const dvsAlertMessageBody = isDvsPassed ? dvsCheckSuccessMessage : dvsCheckFailoursMessage;

  return (
    <div style={{ marginTop: '30px' }}>
      <AuFormItemWrapper>
        {props.arnPath === 'mygov' && <><p>
          Thank you for creating a myCASA account and {props.arnType === 'new' ? 'applying for an' : 'linking your'} aviation reference number. We are processing
          your request. Once complete we will send an email confirming your {props.arnType === 'new' ? '' : 'linked'} aviation reference
          number to <strong>{props.userEmail}</strong>.
        </p>
        <p>You should receive this email within the next 2 minutes.</p>
        </>}
        {props.arnPath === 'dvs' && dvsAlertMessageBody}

      </AuFormItemWrapper>
      <br />
    </div>
  );
};

export default ApplicationSuccessful;
